import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchCashRoundingDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'cash_rounding/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };
  return common.getDropdownList(app, { query });
}

export function saveCashRounding(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const cashRoundingData = {
    doc_type: DocType.CASH_ROUNDING,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    currency_id: data.currency_id,
    round_to: util.toDecimal(data.round_to),
    method: util.toStringText(data.method),
    middle_rounding_method: util.toStringText(data.middle_rounding_method)
  };
  return common.saveDoc(app, {
    source: data,
    doc: cashRoundingData,
    user,
  });
}

export function deleteCashRounding(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.CASH_ROUNDING
  });
}

export function fetchCashRoundingById(app, params) {
  const { id } = params;
  const docType = DocType.CASH_ROUNDING;
  return common.getDoc(app, { id, docType });
}
